import { CommonConfigurationType } from "./commonConfigurationType";

export const COMMON_CONFIGURATION: CommonConfigurationType = {
	WelcomePopupDelay: 30000,
	AllowedFileExtensions: [".png", ".jpg", ".jpeg", ".bmp"],
};
